module.exports = __webpack_public_path__ + "static/media/addvideo_step1.e24521cc.png";